import React from "react";
import { withStyles } from "@mui/styles";

import PageWrapper from "../../components/pageWrapper/PageWrapper";

const styles = (theme) => ({
  root: {
    width: "100%",
  },
});

function SplashPage() {
  return <PageWrapper showHeader={true}></PageWrapper>;
}

export default withStyles(styles)(SplashPage);
